var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1859_4662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5745 17.3521C15.4756 17.3521 15.3766 17.3144 15.3011 17.2389C15.1501 17.0879 15.1501 16.843 15.3011 16.692L16.692 15.3011C16.843 15.1501 17.0878 15.1501 17.2389 15.3011C17.3899 15.4521 17.3899 15.697 17.2389 15.848L15.848 17.2389C15.7725 17.3144 15.6735 17.3521 15.5745 17.3521Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5445 18.3412L16.0419 13.8387C17.7657 11.1088 17.4393 7.44633 15.0627 5.06964C13.7281 3.73502 11.9536 3 10.0661 3C8.17875 3 6.40426 3.73502 5.06964 5.06964C3.73516 6.40423 3 8.17885 3 10.0661C3 11.9536 3.73502 13.7281 5.06964 15.0626C6.40426 16.3972 8.17875 17.1323 10.0661 17.1323C11.4229 17.1323 12.7213 16.7525 13.8399 16.0432L18.3412 20.5444C18.645 20.8481 19.0439 21 19.4428 21C19.8418 21 20.2407 20.8481 20.5445 20.5444C21.1519 19.937 21.1519 18.9486 20.5445 18.3412ZM5.61655 14.5158C4.42799 13.3272 3.77341 11.747 3.77341 10.0661C3.77341 8.38528 4.42799 6.80507 5.61655 5.61651C6.8051 4.42796 8.38532 3.77341 10.0661 3.77341C11.747 3.77341 13.3273 4.42799 14.5158 5.61651C16.9693 8.07005 16.9693 12.0622 14.5158 14.5158C13.3273 15.7043 11.747 16.3589 10.0661 16.3589C8.38532 16.3589 6.80507 15.7043 5.61655 14.5158ZM19.9976 19.9976C19.6917 20.3034 19.194 20.3034 18.8881 19.9976L14.4777 15.5872C14.6807 15.4243 14.876 15.2494 15.0627 15.0627C15.2502 14.8752 15.4248 14.6797 15.5868 14.4773L19.9976 18.8881C20.3034 19.194 20.3034 19.6917 19.9976 19.9976Z",
    fill: "#474747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7351 6.97608C12.6069 7.54544 12.0983 6.91899 11.6609 6.53255C11.3622 6.26858 10.8805 6.17646 10.3797 6.07826C10.1696 6.03706 10.0967 5.83983 10.3068 5.79828C10.6941 5.72166 11.3499 5.81174 11.7213 5.93033C12.317 6.12049 12.7814 6.7703 12.7351 6.97608Z",
    fill: "#474747"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1859_4662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/Search-Icon.6edb7417ca9d63f80e5512e342b28efd.svg";
export { ForwardRef as ReactComponent };